import { create } from 'zustand';

const DESIGN_KEY = 'octo.web.designMode';
interface ShellState {
  drawerOpen: boolean;
  spotlightOpen: boolean;
  settingsOpen: boolean;
  designMode: boolean;
  setDrawer: (open: boolean) => void;
  setSpotlight: (open: boolean) => void;
  setSettings: (open: boolean) => void;
  setDesignMode: (v: boolean) => void;
}
export const useShellStore = create<ShellState>((set) => ({
  drawerOpen: false,
  spotlightOpen: false,
  settingsOpen: false,
  designMode: (() => {
    try {
      return sessionStorage.getItem(DESIGN_KEY) === '1';
    } catch {
      return false;
    }
  })(),
  setDrawer: (drawerOpen) => set({ drawerOpen }),
  setSpotlight: (spotlightOpen) => set({ spotlightOpen }),
  setSettings: (settingsOpen) => set({ settingsOpen }),
  setDesignMode: (designMode) => {
    try {
      sessionStorage.setItem(DESIGN_KEY, designMode ? '1' : '0');
    } catch {
      /* noop */
    }
    set({ designMode });
  },
}));
